import script from "./RevenueForecast.vue?vue&type=script&setup=true&lang=ts"
export * from "./RevenueForecast.vue?vue&type=script&setup=true&lang=ts"

import "./RevenueForecast.vue?vue&type=style&index=0&id=5ed7e290&scoped=true&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed7e290"]])

export default __exports__